document.addEventListener('DOMContentLoaded', function () {
    if (window.jQuery) {

        jQuery(function ($) {

            const params = new URLSearchParams(window.location.search);

            if (params.has('cart-open')) {

                const el = document.querySelector('a.m-cart-icon-bubble');
                if (!el) return;

                // Block navigation ONCE
                el.addEventListener(
                'click',
                function (e) {
                    e.preventDefault();
                },
                { once: true }
                );

                // Trigger native click (theme listener runs)
                el.click();

                // Clean URL
                params.delete('cart-open');
                const cleanUrl =
                window.location.pathname +
                (params.toString() ? '?' + params.toString() : '');

                window.history.replaceState({}, '', cleanUrl);

            }


            if (params.has('filter-family')) {
                const filterValue = params.get('filter-family');
                const $scrollTarget = $("#filter-" + filterValue);

                const loop = setInterval(function () {

                if ($(".sf-65.open").length > 0) {
                    $(".m-accordion--item.open .m-accordion--item-button").trigger("click");
                } else {
                    //add scroll
                    if ($scrollTarget.length) {  
                        $("html, body").animate({
                        scrollTop: $scrollTarget.offset().top - 120
                        }, 400);
                    }
                    $scrollTarget.trigger("click");

                    clearInterval(loop);
                }

                }, 500); 

                // hard stop after 4 seconds
                setTimeout(function () {
                clearInterval(loop);
                }, 4000);
            }


          

            /* =========================
                VARIANT SELECT
                ========================= */
            $(document).on('click', '[data-variant-id]', function () {
                const $btn = $(this);
                const $card = $btn.closest('.simple-product-card, .card-variants').closest('[data-product-id], .simple-product-card');
                const variantId = $btn.data('variant-id');
                const price = $btn.data('price');
                const image_url = $btn.attr('data-image'); // safer than .data()

                console.log("click to cardPrice", price, "image_url", image_url);

                // Update price
                if (price) {
                    $card.find('.card-price').html(price);
                }

                // Update image
                if (image_url) {
                    $card.find('.card-image img').attr({
                        src: image_url,
                        srcset: image_url
                    });
                }

                

                // Fallback: use closest card wrapper
                const $container = $btn.closest('.card-variants');

                // Toggle active state only inside this group
                $btn
                .closest('.variant-group')
                .find('[data-variant-id]')
                .removeClass('is-active')
                .attr('aria-pressed', 'false');

                $btn
                .addClass('is-active')
                .attr('aria-pressed', 'true');

                // Update correct Buy Now button (by product id)
                const productId = $container.attr('id')?.replace('card-variantant-', '');

                $('#buy-button-' + productId)
                .attr('data-variant-id', variantId);
            });

            /* =========================
                QTY BUTTONS
                ========================= */
            $(document).on('click', '.qty-btn', function () {
                const $btn = $(this);
                const productId = $btn.data('id');

                const $input = $('#qty-input-' + productId);
                let qty = parseInt($input.val());
                console.log("qty:"+qty)
                if ($btn.data('action') === 'increase') {
                qty++;
                } else {
                qty--;
                }

                if (qty < 1) qty = 1;

                $input.val(qty);
            });

            /* =========================
                BUY NOW (example hook)
                ========================= */


            $(document).on('click', '.buy-now-btn[data-id]', function (e) {
                e.preventDefault(); 
                console.log("main page")
                const $btn = $(this);
                const productId = $btn.data('id');
                const variantId = $btn.data('variant-id');
                const $qtyInput = $('#qty-input-' + productId);

                let quantity = parseInt($qtyInput.val(), 10);
                if (!quantity || quantity < 1) quantity = 1;
                if (!variantId) return;

                $btn.prop('disabled', true).addClass('loading');

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                    id: variantId,
                    quantity: quantity
                    })
                })
                .then(() => {
                    document.dispatchEvent(
                    new CustomEvent('cart:refresh', { detail: { open: true } })
                    );
                    const url = new URL(window.location.href);
                    url.searchParams.set('cart-open', '1');
                    window.location.href = url.toString();

                })
                .finally(() => {
                    $btn.prop('disabled', false).removeClass('loading');
                });
            });


            /* =========================
            SHOW / HIDE OPTIONS
            ========================= 
            $(document).on('click', '.show-options', function (e) {

            const productId = $(this).data('id');
            const $variants = $('#card-variantant-' + productId);
            const $buyButton = $('#buy-button-' + productId);

            // Toggle visibility
            $variants.toggleClass('is-visible');
            $buyButton.toggleClass('is-visible'); 

            // Optional: change button text
            if ($variants.hasClass('is-visible')) {
                $(this).text('Hide Options');
            } else {
                $(this).text('Show Options');
            }
            });

            */

        });
    }
});



function equalizeSimpleProductCards() {
  let maxHeight = 0;

  // Reset heights first (important for resize)
  $(".simple-product-card").css("height", "auto");

  // Find tallest
  $(".simple-product-card").each(function () {
    let thisHeight = $(this).outerHeight();
    if (thisHeight > maxHeight) {
      maxHeight = thisHeight;
    }
  });

  // Apply tallest height to all
  $(".simple-product-card").css("height", maxHeight + "px");
}

// Run on load
$(window).on("load", function () {
  equalizeSimpleProductCards();
});

$(document).on("click", ".m-toolbar--column-switcher", function(){
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    equalizeSimpleProductCards();
  }, 100);
})
// Run on resize (with small debounce)
let resizeTimer;
$(window).on("resize", function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    equalizeSimpleProductCards();
  }, 100);
});
